import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "App-Talent-T" }
const _hoisted_2 = {
  key: 0,
  class: "App-Talent-T-B",
  success: ""
}
const _hoisted_3 = {
  success: "",
  "f-w-600": ""
}
const _hoisted_4 = { class: "App-Talent-D" }
const _hoisted_5 = { "txt-center": "" }
const _hoisted_6 = { "txt-center": "" }
const _hoisted_7 = { "txt-center": "" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  "txt-center": "",
  "mute-secondary": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _directive_blur = _resolveDirective("blur")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickedTalent && _ctx.clickedTalent(...args))),
    class: "App-Talent"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        (_ctx.user.boost !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[1] || (_cache[1] = _createElementVNode("i", {
                class: "el-icon-top",
                success: ""
              }, null, -1)),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$filters.boost(_ctx.user.boost)), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_avatar, {
          size: 70,
          src: _ctx.user.avatar
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("span", null, [
              _createTextVNode(_toDisplayString(_ctx.$filters.initials(_ctx.user)), 1)
            ])), [
              [_directive_blur, _ctx.user]
            ])
          ]),
          _: 1
        }, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives((_openBlock(), _createElementBlock("h3", null, [
          _createTextVNode(_toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1)
        ])), [
          [_directive_blur, _ctx.user]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.user.areaOfExpertise), 1)
        ]),
        (_ctx.user.startupExperience)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_ctx.user.startupExperience.stages)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_9, _toDisplayString(_ctx.user.startupExperience.stages.join(", ")), 1))
                : _createCommentVNode("", true),
              (_ctx.user.startupExperience.models)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_10, _toDisplayString(_ctx.user.startupExperience.models.join(", ")), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_el_divider),
      (_ctx.user.location)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.user.location.description), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}